import React from 'react';
import PropTypes from 'prop-types';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function Dropdown(props) {
    const { name } = props;
    const { disable } = props ?? false;
    const { currentValue } = props;
    const { handleChange } = props;
    const { data } = props;
    const formattedName = name.replaceAll(" ", "-").toLowerCase();

    return (
        <div>
            <FormControl sx={{ margin: 1, minWidth: 240 }}>
                <InputLabel id={"label-" + formattedName}>{name}</InputLabel>
                <Select
                    labelId={"label-" + formattedName}
                    id={"select-" + formattedName}
                    disabled={disable}
                    value={currentValue}
                    onChange={handleChange}
                    label={name}
                >
                    {data.map(data => {
                        return (
                            <MenuItem key={data.id} value={data.id}>
                                {data.name + ' (' + data.id + ')'}
                            </MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        </div>
    )
}

Dropdown.propTypes = {
    name: PropTypes.string,
    disable: PropTypes.bool,
    currentValue: PropTypes.number,
    handleChange: PropTypes.func,
    data: PropTypes.array
}